export default __webpack_public_path__ + "static/media/01_DAIF_Data_03_03_end.7239e339.jpg";